import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";

export interface AuthContextType {
	auth: string | null;
	setAuth: Setter<AuthContextType["auth"]>;
}

const AuthContext = createContext<AuthContextType | "NOT_INSIDE_PROVIDER">(
	"NOT_INSIDE_PROVIDER",
);

export function AuthProvider({ children }: { readonly children: React.ReactNode; }) {
	const [auth, setAuth] = useLocalStorage<AuthContextType["auth"]>(
		"token_mrp",
		null,
	);

	const value: AuthContextType = useMemo(() => ({
		auth: auth,
		setAuth: setAuth,
	}), [auth, setAuth]);

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
	const context = useContext(AuthContext);
	if (context === "NOT_INSIDE_PROVIDER") {
		throw new Error("useAuth must be used within an AuthProvider");
	}
	return context;
}
